import React from 'react';

import { NumberText } from '../../../components/NumberText/NumberText';
import { FormatNumberOptions } from '../../../types/FormatNumberOptions';

interface Props {
  /** JS `number` */
  number?: number | number[];
  /** Formatting options */
  options?: FormatNumberOptions;
}

export const NumberCell = ({ number, options }: Props) => {
  return <NumberText number={number} options={options} />;
};
